<template>
  <div>

    <Loader v-if="isLoading"></Loader>
    <EXCMCarUserDataForm
      v-else-if="item"
      :closeModal="closeModal"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

<!--    <router-link-->
<!--      v-if="item"-->
<!--      :to="{ name: 'EXCMCarUserDataList' }"-->
<!--      class="btn btn-default">Back to list</router-link>-->
<!--    <button-->
<!--      class="btn btn-danger"-->
<!--      @click="del">Delete</button>-->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMCarUserDataForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMCarUserDataForm,
    Loader
  },

  props: {
    assignationId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmcaruserdata/update/isLoading',
      error: 'excmcaruserdata/update/error',
      deleteError: 'excmcaruserdata/del/error',
      deleteLoading: 'excmcaruserdata/del/isLoading',
      created: 'excmcaruserdata/create/created',
      deleted: 'excmcaruserdata/del/deleted',
      retrieved: 'excmcaruserdata/update/retrieved',
      updated: 'excmcaruserdata/update/updated',
      violations: 'excmcaruserdata/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMCarUserDataList' })
    },

    updated: function (updated) {
      if (this.$route.name === 'ServicemenShow' || this.$route.name === 'DailyPlanShow') {
        this.$store.state.modals.userdata.assignCarUpdate.updated = 1
        this.$store.state.modals.userdata.assignCarUpdate.close = 1
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    if (this.assignationId) {
      this.retrieve(this.assignationId)
    } else {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      createReset: 'excmcaruserdata/create/reset',
      deleteItem: 'excmcaruserdata/del/del',
      delReset: 'excmcaruserdata/del/reset',
      retrieve: 'excmcaruserdata/update/retrieve',
      updateReset: 'excmcaruserdata/update/reset',
      update: 'excmcaruserdata/update/update',
      updateRetrieved: 'excmcaruserdata/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmcaruserdata ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      if (this.retrieved.dateTo) {
        this.retrieved.dateTo = this.$moment(this.retrieved.dateTo).format('YYYY-MM-DD  23:59:59')
      }
      if (this.retrieved.dateFrom) {
        this.retrieved.dateFrom = this.$moment(this.retrieved.dateFrom).format('YYYY-MM-DD')
      }
      this.update()
    },

    closeModal () {
      this.$store.state.modals.userdata.assignCarUpdate.close = 1
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
